<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基础信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box">
                    <p><span>*</span>教材名称：</p>
                    <a-input class="input" v-model="info.name" :disabled="type=='look'||type=='examine'" />
                </div>
                <div class="input-box">
                    <p><span>*</span>作者：</p>
                    <a-input class="input" v-model="info.author" :disabled="type=='look'||type=='examine'" />
                </div>
                <div class="input-box">
                    <p><span>*</span>出版社：</p>
                    <a-input class="input" v-model="info.press" :disabled="type=='look'||type=='examine'" />
                </div>
                <div class="input-box">
                    <p>出版年月：</p>
                    <a-month-picker class="input" v-model="info.publishDate" @change="(date, dateString)=>{info.publishDate=dateString}" :disabled="type=='look'||type=='examine'"/>
                </div>
                <div class="input-box">
                    <p>ISBN：</p>
                    <a-input class="input" v-model="info.isbn" :disabled="type=='look'||type=='examine'" />
                </div>
                <div class="input-box">
                    <p>版次：</p>
                    <a-input class="input" v-model="info.edition" :disabled="type=='look'||type=='examine'" />
                </div>
                <div class="input-box">
                    <p>是否马工程：</p>
                    <a-select 
                        class="input" 
                        allowClear 
                        v-model="info.isMarx" 
                        :disabled="type=='look'||type=='examine'" >
                        <a-select-option :value="true">是</a-select-option>
                        <a-select-option :value="false">否</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>是否国家级规划教材：</p>
                    <a-select 
                        class="input" 
                        allowClear 
                        v-model="info.isStateLevel" 
                        :disabled="type=='look'||type=='examine'" >
                        <a-select-option :value="true">是</a-select-option>
                        <a-select-option :value="false">否</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>是否全英语：</p>
                    <a-select 
                        class="input" 
                        allowClear 
                        v-model="info.isAllEnglish" 
                        :disabled="type=='look'||type=='examine'" >
                        <a-select-option :value="true">是</a-select-option>
                        <a-select-option :value="false">否</a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>教材封面附件</h3>
                <p></p>
            </div>
            <a-upload-dragger
                class="upload-box"
                name="file"
                list-type="picture-card"
                :multiple="true"
                :action="$store.state.axiosUrl+'/api-f/files'"
                :headers="headers"
                @change="fileChange"
                :file-list="fileList"
                :disabled="type=='look'||type=='examine'"
            >
                <p class="ant-upload-drag-icon" v-if="fileList<1">
                    <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text" v-if="fileList<1">点击或拖拽文件上传</p>
            </a-upload-dragger>
        </div>
        <div class="info-box" v-if="type!='add'&&type!='update'">
            <div class="info-title">
                <h3>审批意见</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box input-box-big">
                    <p>意见：</p>
                    <a-textarea class="input" v-model="opinion" :rows="4" :disabled="type!='examine'"/>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type=='examine'" @click="approveClick('approved')">同意</a-button>
            <a-button type="primary" class="reject-btn" v-if="type=='examine'" @click="approveClick('reject')">驳回</a-button>
            <a-button type="primary" v-if="type!='look'&&type!='examine'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info,approve } from '@/baseAPI/undergraduate/culture/teaching'
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                info:{
                    name:null,
                    author:null,
                    press:null,
                    publishDate:null,
                    isbn:null,
                    edition:null,
                    isMarx:null,
                    isStateLevel:null,
                    isAllEnglish:null,
                    coverFile:null,
                },
                fileList:[],
                opinion:'',
            }
        },
        mounted () {
            this.type=this.$route.query.type;
            if(this.type!='add'){
                info(this.$route.query.id).then(res=>{
                    this.info=res.data;
                    this.fileList=[];
                    this.fileList.push({
                        uid: 0,
                        name: this.info.coverFile,
                        status: 'done',
                        url: this.$store.state.axiosUrl+this.info.coverFile,
                    })
                })
            }

        },
        methods:{
            fileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.info.coverFile=res.url;
                }else if(file.file.status=='removed'){
                    var num=this.fileList.indexOf(file.file);
                    this.info.coverFile='';
                    this.fileList.splice(num, 1)
                }
                this.fileList=file.fileList;
            },
            sub(){
                var isSub=true;
                var arr=['name','author','press','publishDate']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增教材成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改教材成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            kcChange(value){
                for(let i=0;i<this.kcArr.length;i++){
                    if(this.kcArr[i].courseName==value){
                        this.info.courseCode=this.kcArr[i].courseCode
                    }
                }
            },
            teacherSelect(){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==this.info.teacherNo){
                        this.info.teacherName=this.jsArr[i].teacherName
                        this.info.orgName=this.jsArr[i].orgName
                        this.info.orgCode=this.jsArr[i].orgCode
                    }
                }
            },
            approveClick(state){
                var obj={
                    id:this.$route.query.id,
                    approvalComments:this.opinion,
                    approveStatus:state,
                }
                approve(obj).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'教材'+(state=='approved'?'审批通过':'驳回成功'),
                        });
                        this.$router.go(-1)
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })

            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box-half{
        width: 49.5%;
    }
    .info-main .input-box-big{
        width: 88%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box p span{
        color: #ff0000;
        margin-right: 5px;
    }
    .info-main .input-box .input{
        width: calc(100% - 12rem);
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .upload-box{
        margin-top: 2rem;
        display: block;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }
    .reject-btn{
        background-color: #ffa500;
        border-color: #ffa500;
    }
</style>
